import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import type { EventAuthDetails, EventWithCustomPages } from "src/types";

import { getState } from "@/features/helpers";
import endpoints from "@/utils/endpoints";
import { fetchJSON } from "@/utils/fetchJSON";
import { isError } from "@/utils/is-error";

const get = endpoints();

const initialState = {
  customDomainEvent: null,
  requireSsoLogin: null,
};

export const fetchEventAuthDetails = createAsyncThunk<EventAuthDetails, string>(
  "eventAuth/fetchEventAuthDetails",
  async (slug: string) => {
    const event = await fetchJSON<EventWithCustomPages>(
      get("EVENT_AUTH_DETAILS_API")(slug)
    );

    if (isError(event)) {
      return initialState;
    }

    const {
      require_sso_login: requireSsoLogin,
      custom_domain_event: customDomainEvent,
    } = event;

    return { requireSsoLogin, customDomainEvent };
  }
);

const eventAuthSlice = createSlice({
  name: "eventAuth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchEventAuthDetails.fulfilled, (_state, action) => {
      return action.payload;
    });
  },
});

const getIsCustomDomainEvent = createSelector(
  getState,
  (state) => state.eventAuth?.customDomainEvent
);

const getRequireSsoLogin = createSelector(
  getState,
  (state) => state.eventAuth?.requireSsoLogin
);

const getEventAuthDetailsLoaded = createSelector(
  getState,
  (state) =>
    state.eventAuth?.requireSsoLogin !== null &&
    state.eventAuth?.customDomainEvent !== null
);

export {
  getIsCustomDomainEvent,
  getRequireSsoLogin,
  getEventAuthDetailsLoaded,
};
export default eventAuthSlice.reducer;
